import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./style/style.css";

const root = document.querySelector("#root");

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <BrowserRouter basename="/2023">
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
